export default {
  // mounted() {},
  watch: {
    $route(to: any, from: any) {
      // this.timetableId = this.$route.params.id;
    }
  }
};
